import { PriceEntryMode } from '../types';

/** Returns the price representation users enter for the company's VAT mode. */
export const getPriceForEntryMode = (
  netPrice: number | null | undefined,
  grossPrice: number | null | undefined,
  priceEntryMode?: PriceEntryMode,
): number | undefined => (
  priceEntryMode === PriceEntryMode.VAT_INCLUDED
    ? grossPrice ?? netPrice ?? undefined
    : netPrice ?? grossPrice ?? undefined
);
